/**
 * 更新公告模块
 *
 * 基于 tx.modal 的公告弹窗，业务层可通过 ttx.announcement.show() 或
 * ttx.command.execute('showAnnouncement', ctx) 调用。
 *
 * 公告阅读状态存储在 localStorage key = 'ttx_announcement_read'，
 * 值为 JSON 数组，存储已读公告 id 列表。
 */
(function () {
    var STORAGE_KEY = 'ttx_announcement_read';

    /** 读取已读公告 id 列表 */
    function _loadReadList() {
        try {
            var raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return [];
            var parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) { return []; }
    }

    /** 保存已读公告 id 列表 */
    function _saveReadList(list) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    }

    /** 构建公告内容 DOM */
    function _buildContent(options) {
        var wrapper = document.createElement('div');
        wrapper.style.cssText = 'line-height:1.8;color:#333;font-size:14px;';

        // 版本信息
        if (options.version) {
            var versionEl = document.createElement('div');
            versionEl.style.cssText = 'margin-bottom:16px;padding:8px 12px;background:#f0f6ff;border-left:3px solid ' + ttx.modal._getAccentColor() + ';border-radius:4px;font-weight:500;';
            versionEl.textContent = '版本：' + options.version;
            wrapper.appendChild(versionEl);
        }

        // 正文内容（支持 HTML）
        var contentEl = document.createElement('div');
        contentEl.style.cssText = 'white-space:pre-wrap;word-break:break-word;';
        if (options.content) {
            contentEl.innerHTML = options.content;
        }
        wrapper.appendChild(contentEl);

        // 补充说明
        if (options.footer) {
            var footerEl = document.createElement('div');
            footerEl.style.cssText = 'margin-top:16px;padding-top:12px;border-top:1px solid #f0f0f0;color:#999;font-size:12px;';
            footerEl.textContent = options.footer;
            wrapper.appendChild(footerEl);
        }

        return wrapper;
    }

    // ========== API ==========

    ttx.announcement = {
        /**
         * 判断公告是否已读
         * @param {string} id - 公告唯一标识
         * @returns {boolean}
         */
        isRead: function (id) {
            if (!id) return true;
            var list = _loadReadList();
            return list.indexOf(id) !== -1;
        },

        /**
         * 标记公告为已读
         * @param {string} id - 公告唯一标识
         */
        markAsRead: function (id) {
            if (!id) return;
            var list = _loadReadList();
            if (list.indexOf(id) === -1) {
                list.push(id);
                _saveReadList(list);
            }
        },

        /**
         * 清除所有已读记录
         */
        clearReadHistory: function () {
            try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        },

        /**
         * 显示公告弹窗
         *
         * @param {object} options
         *   id        - 公告唯一标识（用于记录已读状态）
         *   title     - 弹窗标题，默认 '更新公告'
         *   content   - 公告正文（支持 HTML）
         *   version   - 版本号，显示在正文上方
         *   footer    - 底部补充说明文字
         *   forceShow - 强制显示（忽略已读状态），默认 false
         *   width     - 弹窗宽度，默认 520
         *   confirmText - 确认按钮文字，默认 '知道了'
         *   onConfirm - 确认回调
         *   onClose   - 关闭回调
         *
         * @returns {Promise<boolean>} — 确认返回 true，关闭返回 false
         */
        show: function (options) {
            var opts = options || {};
            var id = opts.id || '';

            // 非强制模式：已读则跳过
            if (!opts.forceShow && id && this.isRead(id)) {
                ttx.console.log('[announcement] 公告已读，跳过:', id);
                return Promise.resolve(false);
            }

            return new Promise(function (resolve) {
                var contentWrapper = _buildContent(opts);

                // "不再提醒" 复选框容器
                var checkboxRow = document.createElement('div');
                checkboxRow.style.cssText = 'margin-top:16px;padding-top:12px;border-top:1px solid #f0f0f0;display:flex;align-items:center;gap:6px;';

                var checkbox = document.createElement('input');
                checkbox.type = 'checkbox';
                checkbox.id = 'tx-announcement-noremind';
                checkbox.style.cssText = 'width:14px;height:14px;cursor:pointer;accent-color:' + ttx.modal._getAccentColor() + ';';

                var checkboxLabel = document.createElement('label');
                checkboxLabel.setAttribute('for', 'tx-announcement-noremind');
                checkboxLabel.style.cssText = 'font-size:13px;color:#999;cursor:pointer;user-select:none;';
                checkboxLabel.textContent = '不再提醒';

                checkboxRow.appendChild(checkbox);
                checkboxRow.appendChild(checkboxLabel);
                contentWrapper.appendChild(checkboxRow);

                var instance = ttx.modal._create({
                    title: opts.title || '更新公告',
                    content: contentWrapper,
                    width: opts.width || 520,
                    bodyMaxHeight: opts.bodyMaxHeight || '50vh',
                    showCancel: false,
                    confirmText: opts.confirmText || '知道了',
                    showWindowControls: true,
                    closeOnMask: false,
                    closeOnEsc: true,
                    zIndex: opts.zIndex || 3000,
                    onConfirm: function () {
                        if (id && checkbox.checked) {
                            ttx.announcement.markAsRead(id);
                        }
                        if (typeof opts.onConfirm === 'function') opts.onConfirm();
                        resolve(true);
                    },
                    onClose: function (trigger) {
                        if (trigger === 'esc' || trigger === 'header-close') {
                            if (id && checkbox.checked) {
                                ttx.announcement.markAsRead(id);
                            }
                        }
                        if (trigger !== 'confirm') resolve(false);
                        if (typeof opts.onClose === 'function') opts.onClose(trigger);
                    }
                });
            });
        }
    };
})();
